import Vue from 'vue';
import Vuex from 'vuex';

import poweredBy from './poweredBy.module';
import auth from './auth.module';
import patientUser from './patientUser.module';
import patientDependents from './patientDependents.module';
import patientCovenants from './patientCovenants.module';
import patientAddresses from './patientAddresses.module';
import patientProfessionals from './patientProfessionals.module';
import calendars from './calendars.module';

import patientSchedules from './patientSchedules.module';
import covenants from './covenants.module';
import kinship from './kinship.module';
import professionals from './professionals.module';
import specialities from './specialities.module';
import serviceChannel from './serviceChannel.module';
import coupons from './coupons.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    poweredBy,
    auth,
    patientUser,
    patientDependents,
    patientCovenants,
    patientAddresses,
    patientProfessionals,
    patientSchedules,
    kinship,
    covenants,
    professionals,
    specialities,
    calendars,
    serviceChannel,
    coupons,
  },
});
